import React, { useState } from "react";
import { Modal, Spin } from "antd";
import { Input } from "antd";
import { toast } from "react-toastify";
import { LoadingOutlined } from "@ant-design/icons";
import { useFinishedMutation } from "../../redux/gemo/gemo";
import { useNavigate } from "react-router";

function OncoWorkDoneModal({ isModalOpen, setIsModalOpen, id }) {
  const { TextArea } = Input;
  const [finished, { isLoading }] = useFinishedMutation();
  const [work, setWork] = useState();
  const navigate = useNavigate()

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleOk = async () => {
    const dataFinsh = {
      code: id.id,
      workDone: work,
    };
    console.log(dataFinsh);
    await finished(dataFinsh);
    toast.success("Bajarildi");
    setIsModalOpen(false);
    setWork("");
    navigate('/adminGemo')
  };
  return (
    <div>
      <Spin spinning={isLoading} tip="Loading...">
        <Modal
          title={id.name}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText={
            isLoading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{
                      fontSize: 20,
                      color: "white",
                    }}
                    spin
                  />
                }
              />
            ) : (
              <span>Ok</span>
            )
          }
        >
          <TextArea
            rows={4}
            value={work}
            onChange={(e) => setWork(e.target.value)}
          />
        </Modal>
      </Spin>
    </div>
  );
}

export default OncoWorkDoneModal;
